<template>
    <div class="modal fade" id="loginModal" role="dialog" style="display: none">
        <div class="modal-dialog">

            <div class="modal-content" @keyup.enter="submit">
                <div class="modal-header">
                    LOGIN
                </div>
                <div id="login-form" class="modal-body">
                    <p class="error-message" style="color: red; font-size: 15px;"></p>
                    <div id="loading-progress" style="overflow: hidden; display: none;">
                        <div style="text-align: center; margin-bottom: 10px;">
                            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control" name="UserName" id="UserName" placeholder="USERNAME" v-model="userInfo.UserName" />
                        <input type="hidden" name="ReturnURL" id="ReturnURL" :value="userInfo.ReturnURL" />
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" name="Password" id="PASSWORD" placeholder="PASSWORD" v-model="userInfo.Password">
                    </div>

                    <div class="btnOK" v-if="layoutHub == 'darkness'">
                        <button id="btnChangePasswordOk" type="submit" class="dlgBtnOk" @click="submit"></button>
                    </div>
                    <div class="row" v-if="layoutHub !='darkness'">
                        <button id="btnchangepasswordok" type="submit" class="col-sm-3 btn btn-success btn-sm btn-login" @click="submit">ok</button>
                    </div>
                </div>
            </div>
        </div>
         </div>
</template>
<script>

import * as loginService from '../services/loginService'
export default {
    data: function() {
        return {
            userInfo: {
                UserName: '',
                Password: '',
                isLogin: true,
                ReturnURL: ''
            }
        }
    },
    props: {
        isShow: false,
        layoutHub: String
    },
    methods: {
        submit: function() {
            if(this.userInfo.UserName.trim() == '' || this.userInfo.Password.trim() == ''){
                $('.error-message').html('Please enter a valid account');
                return;
            }
            $('.error-message').html('');
            
            loginService.login(this);
        }
    },
    watch: {
        isShow: function(newValue){
            loginService.isShow(newValue);
        }
    }
}
</script>